import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../Logo";
import { useAuth } from "../../context/AuthContext";

const links = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "bg-obsidian/80 backdrop-blur-xl border-b border-white/5" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" aria-label="Zork Media home"><Logo size={32} /></Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400 hover:text-volt transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <button
              data-testid="nav-dashboard-btn"
              onClick={() => navigate("/dashboard")}
              className="bg-volt text-obsidian font-mono text-[11px] uppercase tracking-[0.2em] font-bold px-5 py-2.5 hover:bg-[#CCEE00] transition-colors duration-300"
            >
              Portal / {user.zid}
            </button>
          ) : (
            <>
              <button
                data-testid="nav-login-btn"
                onClick={() => navigate("/login")}
                className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300 hover:text-volt transition-colors duration-300 px-4 py-2.5"
              >
                Login
              </button>
              <a
                data-testid="nav-request-access-btn"
                href="#contact"
                className="bg-volt text-obsidian font-mono text-[11px] uppercase tracking-[0.2em] font-bold px-5 py-2.5 hover:bg-[#CCEE00] transition-colors duration-300"
              >
                Request Access
              </a>
            </>
          )}
        </div>
      </div>
    </motion.header>
  );
}
